// extracted by mini-css-extract-plugin
export default {"wrapper":"zq-z","response":"Aq-z","error":"Bq-z","disabled":"Cq-z","buttons":"Dq-z","feedbackQuestionSection":"Eq-z","yesNoWrapper":"Fq-z"};